import { createSelector } from '@reduxjs/toolkit';

import { hasAllRequiredDocs } from '@/shared/utils/hasAllRequiredDocs';

import { getCurrentUploads } from './selectors';
import { carUploadSelectors } from './upload-slice';

const getHasRequiredCarDocs = createSelector(
  getCurrentUploads,
  carUploadSelectors.getDocDefinitions,
  hasAllRequiredDocs,
);

export { getHasRequiredCarDocs };
